import React, { useEffect, useRef, useState } from "react";
import { Box, Button, Card, Divider, Grid, Typography } from '@curves/ui-base';

import { GradesChartBox, GradesTypeSelector, AgeRangeSelector, MonthSelector, ClubSelector } from "@Local/Grades";
import { loadGradesData } from "@Local/Grades/Components/gradesDataLoader";
const GradesPage = () => {
	const [selectedType, setSelectedType] = useState("");
	const [selectedAges, setSelectedAges] = useState([]);
	const [selectedClubs, setSelectedClubs] = useState([]);
	const [selectedMonth, setSelectedMonth] = useState("");
	const [chartHeight, setChartHeight] = useState(500);
	const [isSearching, setIsSearching] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const chartRef = useRef(null);
	const handleTypeChange = type => {
		setSelectedType(type);
		setIsSearching(false); //重置
	};
	const handleMonthChange = month => {
		setSelectedMonth(month);
		setIsSearching(false);
	};
	const handleAgeChange = ages => {
		setSelectedAges(ages);
		setIsSearching(false);
	};
	const handleClubChange = clubs => {
		setSelectedClubs(clubs);
		setIsSearching(false);
	};
	const handleSearch = async () => {
		if (selectedType && selectedAges.length > 0 && selectedClubs.length > 0) {
			setIsLoading(true);
			try {
				const { gradesData, ageGroupData, clubsData } = await loadGradesData(selectedMonth);
				const updateChart = () => {
					if (chartRef.current) {
						chartRef.current.setAgeGroupData(ageGroupData || []);
						chartRef.current.updateChartData(gradesData || [], selectedType, selectedAges, selectedClubs, clubsData);
						chartRef.current.setMonth(selectedMonth);
					}
				};
				updateChart();
				setTimeout(updateChart, 100);
				setIsSearching(true);
			} catch (error) {
				console.error("載入資料失敗:", error);
			} finally {
				setIsLoading(false);
			}
		}
	};
	// 檢查是否可以搜尋
	const canSearch = selectedType && selectedAges.length > 0 && selectedClubs.length > 0;
	// 設定圖表高度
	useEffect(() => {
		const handleResize = () => {
			setChartHeight(window.innerHeight - 270);
		};
		handleResize();
		window.addEventListener("resize", handleResize);
		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);
	// 監聽圖表高度變化
	useEffect(
		() => {
			if (chartRef.current) {
				chartRef.current.triggerResize("100%", `${chartHeight}px`);
			}
		},
		// eslint-disable-next-line
		[chartHeight]
	);
	return (
		<>
			<Box className={"main-container-spacing"}>
				<Typography variant="h4" className="mb-4">
					會員排名成績單
				</Typography>
				<Grid container spacing={2}>
					<Grid item xs={9}>
						<Card className={"px-4 py-3 mb-4"}>
							<Card.CardContent>
								{isSearching ? (
									<>
										<GradesChartBox
											ref={chartRef}
											style={{
												width: "100%",
												height: `${chartHeight}px`,
												minHeight: "400px",
											}}
										/>
									</>
								) : (
									<Typography variant="h6" color="textSecondary" style={{ textAlign: "center", padding: "20px" }}>
										{!selectedType
											? "請選擇查詢類型"
											: !selectedMonth
											? "請選擇查詢月份"
											: !selectedAges.length
											? "請選擇年齡範圍"
											: !selectedClubs.length
											? "請選擇店舖"
											: "請點擊按鈕產生圖表"}
									</Typography>
								)}
							</Card.CardContent>
						</Card>
					</Grid>
					<Grid item xs={3}>
						<Card className={"px-4 py-3 mb-4"}>
							<Typography variant="h6" className="mb-3">
								進步值查詢
							</Typography>
							<Grid container spacing={1}>
								<Grid item xs={6}>
									<GradesTypeSelector selectedType={selectedType} onTypeChange={handleTypeChange} />
								</Grid>
								<Grid item xs={6}>
									<MonthSelector selectedMonth={selectedMonth} onMonthChange={handleMonthChange} count={3} />
								</Grid>
							</Grid>
							<Divider className="my-4" />
							<AgeRangeSelector selectedAges={selectedAges} onAgeChange={handleAgeChange} />
							<Divider className="my-4" />
							<ClubSelector selectedClubs={selectedClubs} onClubChange={handleClubChange} />
							<Button variant="contained" color="primary" fullWidth disabled={!canSearch || isLoading} onClick={handleSearch} style={{ marginTop: "35px" }}>
								{isLoading ? "載入中..." : "產生圖表"}
							</Button>
						</Card>
					</Grid>
				</Grid>
			</Box>
		</>
	);
};
export default GradesPage;
